import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/YoutubeColor.tsx
const YoutubeColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M20.884 7.534a2.326 2.326 0 0 0-1.637-1.636C17.794 5.5 11.983 5.5 11.983 5.5s-5.812 0-7.265.382a2.374 2.374 0 0 0-1.636 1.652C2.699 8.987 2.699 12 2.699 12s0 3.028.383 4.466a2.327 2.327 0 0 0 1.636 1.636c1.468.398 7.265.398 7.265.398s5.811 0 7.264-.382a2.326 2.326 0 0 0 1.637-1.637c.382-1.453.382-4.466.382-4.466s.016-3.028-.382-4.48Z",
		fill: "red"
	}), /* @__PURE__ */ jsx("path", {
		d: "M10.133 9.217v5.567L14.966 12l-4.833-2.783Z",
		fill: "#fff"
	})]
}));
export { YoutubeColorIcon };
